module.exports = "/assets/data/45ac16458997f5d7f2b03a768df2e9a3-BD3.data.json";